document.addEventListener("DOMContentLoaded", () => {

  let mainMenu = null;

  const menuButton = document.getElementById("menuButton");
  const menuLeft = document.getElementById("menu-left");
  const isPetsSite = window.location.hostname.startsWith("pet.");
  const iterator = isPetsSite ? 0 : 1;

  if (menuButton) {
    menuButton.addEventListener("click", () => {
      if (!mainMenu) {
        const raw = document.getElementById("mainMenuData").textContent;
        mainMenu = JSON.parse(raw);
        menuLeft.classList.remove("d-none");
      }

      const menuItems = isPetsSite ? mainMenu : mainMenu.slice(1);

      menuItems.forEach((menuElement, mainIndex) => {
        menuElement.links.forEach((subMenu, subIndex) => {
          const isActive = subMenu.current === true;
          const hasChildren = subMenu.links && subMenu.links.length > 0;
          const submenuId = `subMenu-${mainIndex + iterator}-${subIndex}`;
          const submenuTitleId = `subMenuTitle-${mainIndex + iterator}-${subIndex}`;
          const subMenuContainer = document.getElementById(submenuId);
          const titleContainer = document.getElementById(submenuTitleId);

          if (titleContainer) {
            titleContainer.innerHTML = `
              <a
                class="mobile-menu c-list-menu-left__child-link${isActive ? " is-active" : ""} d-md-none"
                href="${subMenu.url}"
                js-menu-child-level
              >
                ${subMenu.title}
                <span class="d-md-none">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 -960 960 960"
                    width="24"
                    height="24"
                    fill="#00000"
                  >
                    <path d="M514.96-480.67 348.14-647.48Q337.12-658.5 337.46-674q.33-15.5 11.35-26.52t26.86-11.02q15.83 0 26.85 11.02l193.1 193.09q5.89 5.89 8.57 12.6 2.69 6.7 2.69 14.16 0 7.47-2.69 14.17-2.68 6.7-8.57 12.59L401.85-260.14q-11.02 11.02-26.52 10.68-15.5-.33-26.52-11.35t-11.02-26.86q0-15.83 11.02-26.85l166.15-166.15Z"/>
                  </svg>
                </span>
              </a>
            `;
          }

          if (!subMenuContainer || !subMenu.links) return;

          if (subMenuContainer.innerHTML.trim() === "") {
            subMenu.links.forEach((grandchild) => {
              const isActive = grandchild.current === true;
              const li = document.createElement("li");
              li.className = "c-list-menu-left__grandchild-li";
              li.setAttribute("js-menu-content", "");

              li.innerHTML = `
                <div class="tag-container">
                  <a class="c-list-menu-left__grandchild-link${isActive ? " is-active" : ""}" href="${grandchild.url}">
                    ${grandchild.title}
                  </a>
                  ${grandchild.tag ? `
                    <div class="tag-badge" style="background-color: ${grandchild.tag.color};">
                      ${grandchild.tag.name}
                    </div>` : ""}
                </div>
              `;
              subMenuContainer.appendChild(li);
            });
          }
        });
      });
    });
  }
});